import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PERMISSIONS, PERMISSIONS_LIST } from "../const/permissions.const";
import { IReduxAppState } from "../reducers";
import { useSnackbarMessages } from "../yoello-lib/modules/components/snackbar/SnackbarContext";
import { useTranslation } from "react-i18next";

const useCheckPermissions = (permission: PERMISSIONS, defaultState = true) => {
    const permissions = useSelector((state: IReduxAppState) => state.permissions);
    const isSuperUser = useSelector((state: IReduxAppState) => state.merchant?.superuser);
    const [ hasPermission, setHasPermission ] = useState<boolean>(defaultState);

    const { t } = useTranslation();
    const { sendSnackbarMessage } = useSnackbarMessages()!;

    const onFailedInteraction = () => {
        if(!hasPermission){
            sendSnackbarMessage(t(`snackbar.permissions.failure.${permission}`), "error");
        }
    }

    useEffect(() => {
        if(permission && permissions){
            if(PERMISSIONS_LIST[permission].requiredForSuperuser && isSuperUser) {
                setHasPermission(true);
            } else {
                setHasPermission(permissions[permission]);
            }
            
            
        }
    }, [permission, permissions, defaultState, isSuperUser])

    return { 
        hasPermission,
        onFailedInteraction
    };
}

export default useCheckPermissions;